module.exports = __webpack_public_path__ + "img/new-tsgn_tab3.f2bc9264.png";